module.exports = "<div class=\"add-new-item\" (click)=\"onButtonClicked()\" [ngClass]=\"{ 'add-new-item-disabled': false }\">\n    <i class=\"{{icon}} mr-18\" *ngIf=\"icon\"></i>\n    <img [src]=\"imgSrc\" class=\"add-new-pic\" *ngIf=\"imgSrc\">\n    <div>\n        <h2 class=\"an-item-title\">{{ title }}</h2>\n        <div class=\"an-item-description\">{{ description }}</div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.html
// module id = ./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.html
// module chunks = 0